<div class="container" style="padding: 16px;">
  <div class="form-container">
    <div>
      <h2 class="body-large-bold no-margin">Terms of Use</h2>
      <p class="body-medium-regular">
        Last updated: June 12, 2024
        <br>
        Please read these terms and conditions carefully before using Our Service.
      </p>

      <h2 class="body-large-bold no-margin">Interpretation</h2>
      <p class="body-medium-regular">The words of which the initial letter is capitalized have meanings defined under
        the following conditions. The
        following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
      </p>

      <h2 class="body-large-bold no-margin">Definitions</h2>
      <p class="body-medium-regular no-margin">For the purposes of these Terms and Conditions:</p>
      <ul>
        <li><strong class="body-medium-bold">Affiliate</strong> means an entity that controls, is controlled by or is
          under common control with a
          party, where "control" means ownership of 50% or more of the shares, equity interest or other securities
          entitled to vote for election of directors or other managing authority.</li>
        <li><strong class="body-medium-bold">Country</strong> refers to: Malaysia</li>
        <li><strong class="body-medium-bold">Company</strong> (referred to as either "the Company", "We", "Us" or "Our"
          in this Agreement) refers
          to Zeoniq, 10-01, Tower 5, UOA Business Park, Jalan Pengaturcara U1/51, Seksjen U1, 40150 Shah Alam, Selangor.
        </li>
        <li><strong class="body-medium-bold">Device</strong> means any device that can access the Service such as a
          computer, a cellphone or a
          digital tablet.</li>
        <li><strong class="body-medium-bold">Service</strong> refers to the Website.</li>
        <li><strong class="body-medium-bold">Terms and Conditions</strong> (also referred to as "Terms") mean these
          Terms and Conditions that
          form the entire agreement between You and the Company regarding the use of the Service.</li>
        <li><strong class="body-medium-bold">Third-party Social Media Service</strong> means any services or content
          (including data,
          information, products or services) provided by a third-party that may be displayed, included or made available
          by the Service.</li>
        <li><strong class="body-medium-bold">Website</strong> refers to Zeoniq e-order, accessible from <a
            href="http://www.zeoniq.com">www.zeoniq.com</a></li>
        <li><strong class="body-medium-bold">You</strong> means the individual accessing or using the Service, or the
          company, or other legal
          entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
      </ul>

      <h2 class="body-large-bold no-margin">Acknowledgment</h2>
      <p class="body-medium-regular">These are the Terms and Conditions governing the use of this Service and the
        agreement that operates between
        You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the
        use of the Service.
        <br>
        Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and
        Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.
        <br>
        By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any
        part of these Terms and Conditions then You may not access the Service.
        <br>
        Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy
        Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and
        disclosure of Your personal information when You use the Application or the Website and tells You about Your
        privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service.
      </p>

      <h2 class="body-large-bold no-margin">Links to Other Websites</h2>
      <p class="body-medium-regular">
        Our Service may contain links to third-party web sites or services that are not owned or controlled by the
        Company.
        <br>
        The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices
        of any third party web sites or services. You further acknowledge and agree that the Company shall not be
        responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in
        connection with the use of or reliance on any such content, goods or services available on or through any such
        web sites or services.
        <br>
        We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or
        services that You visit.
      </p>

      <h2 class="body-large-bold no-margin">Termination</h2>
      <p class="body-medium-regular">
        We may terminate or suspend Your access immediately, without prior notice or liability, for any reason
        whatsoever, including without limitation if You breach these Terms and Conditions.
        <br>
        Upon termination, Your right to use the Service will cease immediately.
      </p>

      <h2 class="body-large-bold no-margin">"AS IS" and "AS AVAILABLE" Disclaimer</h2>
      <p class="body-medium-regular">
        The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of
        any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of
        its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties,
        whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties
        of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise
        out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing,
        the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will
        meet Your requirements, achieve any intended results, be compatible or work with any other software,
        applications, systems or services, operate without interruption, meet any performance or reliability standards
        or be error free or that any errors or defects can or will be corrected.
        <br>
        Without limiting the foregoing, neither the Company nor any of the company's provider makes any representation
        or warranty of any kind, express or implied: (i) as to the operation or availability of the Service, or the
        information, content, and materials or products included thereon; (ii) that the Service will be uninterrupted or
        error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through
        the Service; or (iv) that the Service, its servers, the content, or e-mails sent from or on behalf of the
        Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.
        <br>
        Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable
        statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But
        in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent
        enforceable under applicable law.
      </p>

      <h2 class="body-large-bold no-margin">Governing Law</h2>
      <p class="body-medium-regular">
        The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the
        Service. Your use of the Application may also be subject to other local, state, national, or international laws.
      </p>

      <h2 class="body-large-bold no-margin">Disputes Resolution</h2>
      <p class="body-medium-regular">
        If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally
        by contacting the Company.
      </p>

      <h2 class="body-large-bold no-margin">Severability</h2>
      <p class="body-medium-regular">
        If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and
        interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law
        and the remaining provisions will continue in full force and effect.
      </p>

      <h2 class="body-large-bold no-margin">Waiver</h2>
      <p class="body-medium-regular">
        Except as provided herein, the failure to exercise a right or to require performance of an obligation under
        these Terms shall not affect a party's ability to exercise such right or require such performance at any time
        thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.
      </p>

      <h2 class="body-large-bold no-margin">Translation Interpretation</h2>
      <p class="body-medium-regular">
        These Terms and Conditions may have been translated if We have made them available to You on our Service. You
        agree that the original English text shall prevail in the case of a dispute.
      </p>

      <h2 class="body-large-bold no-margin">Changes to These Terms and Conditions</h2>
      <p class="body-medium-regular">
        We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is
        material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking
        effect. What constitutes a material change will be determined at Our sole discretion.
        <br>
        By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the
        revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the
        Service.
      </p>

      <h2 class="body-large-bold no-margin">Contact Us</h2>
      <p class="body-medium-regular no-margin">If you have any questions about these Terms and Conditions, You can contact us:</p>
      <ul>
        <li>By email: <a class="email-link" href="mailto:info@zeoniq.com">info&#64;zeoniq.com</a></li>
      </ul>
    </div>

  </div>
</div>
